//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACCOUNTING_INFO.FETCH.REQUEST:
      return model.loading(initialState)
    case TYPES.ACCOUNTING_INFO.FETCH.SUCCEEDED:
      return model.capturedResponse(state, action.payload)
    case TYPES.ACCOUNTING_INFO.FETCH.FAILED:
      return model.error(state, action.payload)
    case TYPES.ACCOUNTING_INFO.CLEAN.ERRORS:
      return model.clean(state)
    case TYPES.ACCOUNTING_INFO.CLEAN.STATE:
      return model.clean(initialState)
    default:
      return state
  }
}
